/* eslint-disable @typescript-eslint/ban-ts-comment */
// modules
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { openFile } from '@weblite/file'
import { styled } from '@mui/material/styles'
import { WappPanel } from '$logic/wapp-panels'
import {
  ContactsOffIcon,
  CameraOffIcon,
  MutedMicIcon,
  NotificationsOffIcon,
  MicActiveIcon,
  CameraActiveIcon,
  ContactIcon,
  NotificationActiveIcon,
} from '$common/icons'
import { t } from '$i18n'
import { registerNotification } from '$setup/notification'
import { dispatchSetPermissions } from '$comp/main/root.action'
import { RefreshIcon } from '$common/icons/refresh'
import { ClockAlertIcon } from '$common/icons/clock-alert'
import { checkTimeOffset } from '$logic/client-device/time-offset.service'
import { PermissionDialog } from './permission-dialog'
import { setLastNotifPermissionRejectionTime } from '$setup/notification/permission'

const COMPONENT_ID = 'permissionDialog'

const showPermissionTour = (props: Parameters<typeof PermissionDialog>[0]) =>
  addModal({ id: COMPONENT_ID, props })

const BLOGS = {
  // @ts-ignore
  clockMismatch: import.meta.env.VITE_CLOCK_MISMATCH_CONTENT_URI,
  // @ts-ignore
  contact: import.meta.env.VITE_ENABLE_CONTACT_INSTRUCTION_CONTENT_URI,
  // @ts-ignore
  camera: import.meta.env.VITE_ENABLE_CAMERA_INSTRUCTION_CONTENT_URI,
  // @ts-ignore
  mic: import.meta.env.VITE_ENABLE_MIC_INSTRUCTION_CONTENT_URI,
  // @ts-ignore
  notification: import.meta.env
    .VITE_ENABLE_NOTIFICATION_INSTRUCTION_CONTENT_URI,
}

export const showNotificationsPermissionPromptDialog = () => {
  showPermissionTour({
    title: t('permissionModal.promptTitle')(t(`permissionModal.notifications`)),
    description: t('permissionModal.promptDescription')(
      t(`permissionModal.notifications`),
    ),
    icon: <NotificationActiveIcon />,
    promptMode: true,
    firstActionText: t('common.resume'),
    secondActionText: t('common.cancel'),
    onSecondAction: async () => {
      setLastNotifPermissionRejectionTime()
      await closeCurrentModal()
    },
    onFirstAction: async () => {
      registerNotification()
      await closeCurrentModal()
    },
  })
}

const StyledContactsIcon = styled(ContactIcon)`
  width: 64px;
  height: 64px;
`
export const showContactsPermissionPromptDialog = () => {
  showPermissionTour({
    title: t('permissionModal.promptTitle')(t(`permissionModal.contacts`)),
    description: t('permissionModal.promptDescription')(
      t(`permissionModal.contacts`),
    ),
    firstActionText: t('common.resume'),
    secondActionText: t('common.cancel'),
    icon: <StyledContactsIcon />,
    promptMode: true,
    onSecondAction: async () => {
      await closeCurrentModal()
    },
    onFirstAction: async () => {
      await closeCurrentModal()
      // TODO:
    },
  })
}
export const showCameraPermissionPromptDialog = () => {
  showPermissionTour({
    title: t('permissionModal.promptTitle')(t(`permissionModal.camera`)),
    description: t('permissionModal.promptDescription')(
      t(`permissionModal.camera`),
    ),
    firstActionText: t('common.resume'),
    secondActionText: t('common.cancel'),
    icon: <CameraActiveIcon />,
    promptMode: true,
    onSecondAction: async () => {
      await closeCurrentModal()
    },
    onFirstAction: async () => {
      await closeCurrentModal()
      // TODO:
    },
  })
}

export const showMicPermissionPromptDialog = () => {
  showPermissionTour({
    title: t('permissionModal.promptTitle')(t(`permissionModal.mic`)),
    description: t('permissionModal.promptDescription')(
      t(`permissionModal.mic`),
    ),
    firstActionText: t('common.resume'),
    secondActionText: t('common.cancel'),
    icon: <MicActiveIcon />,
    promptMode: true,
    onSecondAction: async () => {
      await closeCurrentModal()
    },
    onFirstAction: async () => {
      await closeCurrentModal()
      navigator.mediaDevices
        .getUserMedia?.({ audio: true })
        .then(stream => {
          dispatchSetPermissions({ mic: 'granted' })
          stream.getTracks().forEach(track => {
            track.stop()
          })
        })
        .catch(e => {
          console.log('error: ', e)
          dispatchSetPermissions({ mic: 'denied' })
        })
    },
  })
}

export const showRecommendUpdateTwaDialog = () => {
  showPermissionTour({
    title: t('permissionModal.updateTwaVersion.title'),
    description: t('permissionModal.updateTwaVersion.description'),
    firstActionText: t('permissionModal.updateTwaVersion.confirmOption'),
    secondActionText: t('permissionModal.updateTwaVersion.cancelOption'),
    icon: <RefreshIcon />,
    promptMode: true,
    onSecondAction: async () => {
      await closeCurrentModal()
    },
    onFirstAction: async () => {
      // @ts-ignore
      const downloadSrc = import.meta.env.VITE_TWA_DOWNLOAD_SRC

      openFile(downloadSrc, '', true)

      await closeCurrentModal()
    },
  })
}

export const showClockMismatchDialog = () => {
  showPermissionTour({
    title: t('permissionModal.clockMismatch.title'),
    description: t('permissionModal.clockMismatch.description'),
    firstActionText: t('permissionModal.infoOption'),
    icon: <ClockAlertIcon />,
    promptMode: false,
    onSecondAction: async () => {
      await closeCurrentModal()
    },
    onFirstAction: async () => {
      await closeCurrentModal()
      WappPanel.openWapp({
        wappId: 'blog-blog-main',
        input: { contentUri: BLOGS.clockMismatch },
      })
    },
  })
}

export const checkClockMismatch = () => {
  checkTimeOffset()
  // if (BLOGS.clockMismatch && isLoggedIn() && (await shouldShowClockDialog())) {
  //   StartUpModalQueue.add({
  //     priority: StartupModalPriorities.clockMismatch,
  //     onOpen: showClockMismatchDialog,
  //   })
  // }
}

export const showNotificationsPermissionDeniedDialog = () => {
  showPermissionTour({
    title: t('permissionModal.deniedTitle')(t(`permissionModal.notifications`)),
    description: t('permissionModal.deniedDescription')(
      t(`permissionModal.notifications`),
    ),
    firstActionText: t('common.understand'),
    secondActionText: t('permissionModal.infoOption'),
    icon: <NotificationsOffIcon />,
    promptMode: false,
    onSecondAction: async () => {
      await closeCurrentModal()
      WappPanel.openWapp({
        wappId: 'blog-blog-main',
        input: { contentUri: BLOGS.notification },
      })
    },
    onFirstAction: async () => {
      await closeCurrentModal()
    },
  })
}

export const showContactsPermissionDeniedDialog = () => {
  showPermissionTour({
    title: t('permissionModal.deniedTitle')(t(`permissionModal.contacts`)),
    description: t('permissionModal.deniedDescription')(
      t(`permissionModal.contacts`),
    ),
    firstActionText: t('common.understand'),
    secondActionText: t('permissionModal.infoOption'),
    icon: <ContactsOffIcon />,
    promptMode: false,
    onSecondAction: async () => {
      await closeCurrentModal()
      WappPanel.openWapp({
        wappId: 'neviseh-neviseh-main',
        input: { contentUri: BLOGS.contact },
      })
    },
    onFirstAction: async () => {
      await closeCurrentModal()
    },
  })
}

export const showCameraPermissionDeniedDialog = () => {
  showPermissionTour({
    title: t('permissionModal.deniedTitle')(t(`permissionModal.camera`)),
    description: t('permissionModal.deniedDescription')(
      t(`permissionModal.camera`),
    ),
    firstActionText: t('common.understand'),
    secondActionText: t('permissionModal.infoOption'),
    icon: <CameraOffIcon />,
    promptMode: false,
    onSecondAction: async () => {
      await closeCurrentModal()
      WappPanel.openWapp({
        wappId: 'neviseh-neviseh-main',
        input: { contentUri: BLOGS.camera },
      })
    },
    onFirstAction: async () => {
      await closeCurrentModal()
    },
  })
}

const StyledMicIcon = styled(MutedMicIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  width: '64px',
  height: '64px',
}))

export const showMicPermissionDeniedDialog = () => {
  showPermissionTour({
    title: t('permissionModal.deniedTitle')(t(`permissionModal.mic`)),
    description: t('permissionModal.deniedDescription')(
      t(`permissionModal.mic`),
    ),
    firstActionText: t('common.understand'),
    secondActionText: t('permissionModal.infoOption'),
    icon: <StyledMicIcon />,
    promptMode: false,
    onSecondAction: async () => {
      await closeCurrentModal()
      WappPanel.openWapp({
        wappId: 'neviseh-neviseh-main',
        input: { contentUri: BLOGS.mic },
      })
    },
    onFirstAction: async () => {
      await closeCurrentModal()
    },
  })
}

export default {
  [COMPONENT_ID]: {
    Component: PermissionDialog,
  },
}
